import styled, { css } from 'styled-components'
import { white, lightergray } from '../../../styles/colors'
import { IconNavDropDown } from '../../../styles/defaults-header'

export const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  background: ${white};
`

export const Item = styled.div`
  padding: 0.8rem 1.25rem 0.8rem 0.25rem;
  cursor: pointer;

  a {
    position: relative;
    display: block;
  }

  &:hover {
    background: ${lightergray};
  }

  ${props =>
    props.active &&
    css`
      background: ${lightergray};

      ${IconNavDropDown} {
        transform: translateY(100%);
        opacity: 1;
      }
    `};
`

export const IconContainer = styled.div`
  position: relative;
  margin-left: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  svg {
    width: 3rem;
    height: 3rem;
    padding: ${props => (props.small ? '.25rem' : '0')};
  }
`



// WEBPACK FOOTER //
// ./src/components/Header/IconNav/styles.js